import { createSlice } from "@reduxjs/toolkit";
import { getRatingDetails } from "../actions/moyasar.actions";
const initialState = {
  isOpen: false as boolean, 
  res_model: null as number | null, 
  reason: "" as string, 
  res_ids: null as any, 
  rated_partner_id: null as any, 
  RatingResponse: {
    loading: false,
    error: null as unknown | null,
    data: {} as any,
  },
};

export const ratingSlice = createSlice({
  name: "rating",
  initialState: initialState,
  reducers: {
    setRatingVisible: (state, action) => {
      state.isOpen = action.payload; 
    },
    setResModel: (state, action) => {
      state.res_model = action.payload; 
    },

    setReason: (state, action) => {
      state.reason = action.payload; 
    },
    setResIds: (state, action) => {
      state.res_ids = action.payload; 
    },
    setRatedPartnerId: (state, action) => {
      state.rated_partner_id = action.payload; 
    },
  },
  extraReducers: (builder) => {
        builder.addCase(getRatingDetails.pending, (state) => {
          state.RatingResponse.loading = true;
        });
        builder.addCase(
          getRatingDetails.fulfilled,
          (state, action) => {
            state.RatingResponse.data = action.payload;
            state.RatingResponse.loading = false;
          }
        );
        builder.addCase(getRatingDetails.rejected, (state, action) => {
          state.RatingResponse.data = [];
          state.RatingResponse.loading = false;
          state.RatingResponse.error = action.payload;
        });
  },
  
});

export const {
  setRatingVisible,
  setResModel,
  setReason,
  setResIds,
  setRatedPartnerId,
} = ratingSlice.actions;

export default ratingSlice.reducer;